export default "__VITE_ASSET__57928ca8__"